(() => {
  'use strict';

  const doc = document;
  doc.documentElement.classList.add('tnt-v2-js');

  const reveal = (scope) => {
    const items = scope.querySelectorAll('[data-v2-reveal]:not([data-v2-reveal-ready])');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach((item) => {
      item.dataset.v2RevealReady = 'true';
      observer.observe(item);
    });
  };

  const initRails = (scope) => {
    const rails = scope.querySelectorAll('[data-v2-rail]:not([data-v2-rail-ready])');

    rails.forEach((rail) => {
      rail.dataset.v2RailReady = 'true';
      const section = rail.closest('.tnt-v2-home');
      const previous = section?.querySelector('[data-v2-prev]');
      const next = section?.querySelector('[data-v2-next]');
      if (!previous || !next) return;

      const update = () => {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      };

      const move = (direction) => {
        const card = rail.querySelector('.tnt-v2-product-card');
        const gap = Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 16;
        const distance = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  const init = (scope = doc) => {
    reveal(scope);
    initRails(scope);
  };

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  doc.addEventListener('shopify:section:load', (event) => init(event.target));
})();
